export default "__VITE_ASSET__STpHf68q__"